var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 4C8 4.1273 7.94943 4.24939 7.85941 4.33941C7.76939 4.42943 7.6473 4.48 7.52 4.48H4.48V7.52C4.48 7.6473 4.42943 7.76939 4.33941 7.85941C4.24939 7.94943 4.1273 8 4 8C3.8727 8 3.75061 7.94943 3.66059 7.85941C3.57057 7.76939 3.52 7.6473 3.52 7.52V4.48H0.48C0.352696 4.48 0.230606 4.42943 0.140589 4.33941C0.0505713 4.24939 0 4.1273 0 4C0 3.8727 0.0505713 3.75061 0.140589 3.66059C0.230606 3.57057 0.352696 3.52 0.48 3.52H3.52V0.48C3.52 0.352696 3.57057 0.230606 3.66059 0.140589C3.75061 0.0505713 3.8727 0 4 0C4.1273 0 4.24939 0.0505713 4.33941 0.140589C4.42943 0.230606 4.48 0.352696 4.48 0.48V3.52H7.52C7.6473 3.52 7.76939 3.57057 7.85941 3.66059C7.94943 3.75061 8 3.8727 8 4Z",
    fill: "#00F58C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusSign);
export default __webpack_public_path__ + "static/media/PlusSign.a2b000a3c1918a43f128b3168a806e3c.svg";
export { ForwardRef as ReactComponent };